import React, { createElement } from 'react';
import { getMediaPath } from '../../../app/functions';
import DynamicLink from '../../../components/dynamic_link';
import './index.scss';

const InsuranceItem = ({ data, onClick = () => {} }) => {
    return (
        <InsuranceItemWrapper data={data} onClick={onClick}>
            <img
                src={getMediaPath(data?.image_path)}
                alt={data?.title}
                className="insurance-image"
            />
        </InsuranceItemWrapper>
    );
};

const InsuranceItemWrapper = ({ children, data, onClick }) => {
    const elementType = data?.automatic_item ? 'div' : DynamicLink;

    return createElement(elementType, {
        data: data?.automatic_item ? null : data?.url_object,
        onClick: onClick,
        className: 'insurance-item-wrapper',
    }, children);
};

export default InsuranceItem;
